import React from 'react';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import FormErrorMessage from '../Errormessage';

const MultiSelectComponent = ({ name, control, label, options, error, messages, required = true, handleChange }) => {

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '5px',
      backgroundColor: '#FFFFFF',
      boxShadow: '#D9D9D9',
      '&:hover': {
        border: '1px solid #D9D9D9',
      },
    }),
    placeholder: () => ({
      display: 'none',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#F8F8FF',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#000000',
      fontWeight: 700,
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#666',
      ':hover': {
        backgroundColor: '#FFFFFF',
        color: '#000000',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected || state.isFocused ? '#FFFFFF' : provided.backgroundColor,
      color: state.isSelected || state.isFocused ? '#000000' : provided.color,
      fontSize: "16px",
      ':active': {
        backgroundColor: '#FFFFFF',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      fontSize: "16px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      fontSize: "16px",
    }),
  };

  return (
    <div style={{ width: "100%", position: 'relative', marginBottom: '30px' }}>
      <label
        style={{
          position: 'absolute',
          top: '-10px',
          left: '10px',
          background: '#fafafa',
          padding: '0 5px',
          fontSize: '12px',
          color: '#858485',
          zIndex: '20',
        }}
      >
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{ required: required }}
        render={({ field: { onChange, onBlur, ref, value } }) => (
          <Select
            isMulti
            onChange={(selected) => {
              onChange(selected || []);
              if (handleChange) {
                handleChange(selected);
              }
            }}
            onBlur={onBlur}
            value={value}
            ref={ref}
            options={options}
            styles={customStyles}
            classNamePrefix="select"
          />
        )}
      />
      <FormErrorMessage error={error} messages={messages} />
    </div>
  );
};

export default MultiSelectComponent;
